module.exports = __webpack_public_path__ + "assets/images/5eed1eb71f0835968733519735efc76e.png";